import { createFileRoute } from '@tanstack/react-router';

import { AdminKlaviyoEventTriggersPage } from '@pages/admin';

export const Route = createFileRoute(
  '/$locale/_authenticated/admin/settings/operations/integrations/klaviyo/event-triggers'
)({
  component: AdminKlaviyoEventTriggers,
});

function AdminKlaviyoEventTriggers() {
  return <AdminKlaviyoEventTriggersPage />;
}
